<template>
    <div class="orderbox">
        <!-- left -->
        <filterBox ref='filterBox' @handleSearch="handleSearch" :buyerTypes="this.levelOne.concat()" />
        <!-- right -->
        <div class="main-cotent">
            <!-- tabs todo-ljm -->
            <vs-tabs v-model="tabIndex">
                <vs-tab :label="item.name" v-for="(item,index) in vsTabsList" :key="index"
                    @click="orderTabChange(item,index)">
                    <div class="top-search" v-if="filtering('overseas:export')">
                        <div class="search-item search-item-border pointer " @click.stop="download()">
                            <img class="search-icon" src="../../../src/assets/images/orderimg/dc.png" alt="">
                            <span class="search-label">导出订单</span>
                        </div>
                    </div>
                    <div class="contentlist">
                        <!-- multiple -->
                        <vs-table v-model="Orderselected" :data="orderdatalist" ref="orderListTable" noDataText="暂无数据">
                            <template slot="thead">
                                <vs-th v-for="(headData, index) in headData" :class="orderThStyle(headData)"
                                    :key="index">{{ headData }}</vs-th>
                            </template>
                            <template slot-scope="{ data }">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                   <!-- '发货单号', -->
                  <vs-td :data="tr.orderNo" style="width: 220px;text-align:center;">
                    <div class="excrete-logo" v-if="tr.parentOrderNo">分</div>
                    <div
                      class="excrete-logo"
                      v-if="tr.combineType == 'combine_ed'"
                    >
                      合
                    </div>
                    {{ tr.orderNo }}<br />{{ tr.bodyName }}</vs-td
                  >
                  <!-- '订货单号', -->
                  <vs-td :data="tr.orderBillNo" style="width: 180px">{{
                    tr.orderBillNo
                  }}</vs-td>
                  <!-- '出库单号', -->
                  <vs-td :data="tr.outOrderBillNo" style="width: 110px">{{
                    tr.outOrderBillNo
                  }}</vs-td>
                  <!-- '物流商/物流单号', -->
                  <vs-td :data="tr.buyerName" style="width: 200px">
                    <div class="buyerName">
                      {{ tr.express }}
                    </div>
                    <div class="buyerType">
                      {{ tr.transportNo }}
                    </div>
                  </vs-td>
                  <!-- '创建日期', -->
                   <vs-td :data="tr.orderTime" style="width: 160px">{{
                    tr.orderTime
                  }}</vs-td>

                    <!-- '商品信息', -->
                   <vs-td :data="tr.skuSummary" style="width: 110px">{{
                    tr.skuSummary
                  }}</vs-td>
                  <!-- '买家/类型', -->
                  <vs-td :data="tr.buyerName" style="width: 200px">
                    <div class="buyerName">
                      {{ tr.buyerName }}
                    </div>
                    <div class="buyerType">
                      {{ tr.buyerType }}
                    </div>
                      <div class="buyerType">
                      {{ tr.buyerCode }}
                    </div>
                  </vs-td>

                  <!-- '订单状态', -->
                  <vs-td :data="tr.buyerName" style="width: 100px">
                   <span class="order-status" :style="orderStatusColorStyle(tr.orderStatus)"></span>
                                {{ tr.orderStatusDesc }}
                                <div v-if="tr.orderStatus == 'ABNORMAL'" style="color:#aaa">{{tr.warnMessage}}</div>
                  </vs-td>

                  <!-- '收件人', -->
                   <vs-td :data="tr.receiveName" style="width: 200px">{{
                    tr.receiveName
                  }}</vs-td>

                   <!-- '联系方式', -->
                   <vs-td :data="tr.receivePhone" style="width: 110px">{{
                    tr.receivePhone
                  }}</vs-td>

                    <!-- '收货地址', -->
                   <vs-td :data="tr.receivePhone" style="width: 200px">
                    {{ tr.province + tr.area + tr.address}}
                  </vs-td>

                  <!-- '发货仓', -->
                   <vs-td :data="tr.sendWs" style="width: 110px">{{
                    tr.sendWs
                  }}</vs-td>

                   <!-- '仓位', -->
                   <vs-td :data="tr.sendLoc" style="width: 110px">{{
                    tr.sendLoc
                  }}</vs-td>
                                    <!-- 增加查看操作 -->
                                    <vs-td class="whitespace-no-wrap fixed-table-column white" style="width: 100px">
                                        <div v-if="filtering('overseas:detail')">
                                            <a href="javascript:;" @click="goDetail(tr)">查看</a>
                                        </div>
                                    </vs-td>

                                </vs-tr>
                            </template>
                        </vs-table>
                        <!-- <gc-vs-pagination-nosize class="pagination" :total="Math.ceil(page.totalCount / page.pageSize)" v-model="page.pageNo" :max-items="page.pageSize"></gc-vs-pagination-nosize> -->
                        <gc-vs-pagination :pager="page" v-if="pageshow" totalName="totalCount" pageNoName='pagerNo'
                            pageSizeName="pageSize" @handleSizeChange="handleSizeChange"
                            @handleCurrentChange="handleCurrentChange"></gc-vs-pagination>
                    </div>
                </vs-tab>
            </vs-tabs>
            <addModal :popupActive="addPopupActive" :detail="detailDataList" />
        </div>
        <BreakUpOrder @success="handleBreakUpOrderSuccess" :visible.sync="breakUpOrderShow"
            :tableData="breakUpOrderList" :orderNo="currentOrderNo" :allStockList="allStockList" />
        <CombineOrder ref="combineOrder" @success="handleCombineOrderSuccess" :visible.sync="combineOrderShow"
            :orderInfo="currCombineOrderInfo" :orderNo="currCombineOrderInfo.orderNo"
            @uptOrderNo="currCombineOrderInfo = {}" />
        <!-- 海外订单详情 -->
        <domesticOrder :title="title" ref="domesticOrder"></domesticOrder>
    </div>
</template>

<script>
    import domesticOrder from '@/modules/orderstore/details/domesticOrder';

    import store from './store.js';
    import filterBox from './filterBox.vue';
    import addModal from './addModal.vue';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select';
    import { OrderApi } from '@/modules/server-api/commodity-sys/order';
    import { LogisticsApi } from '@/modules/server-api/commodity-sys/logistics';
    import { CommodityGoodsyApi } from "@/modules/server-api/commodity-sys/goods-manage";
    import { $busErrorCode, uploadHeader } from '@/modules/commodity-sys/common.js';
    import {
        WmsWarehouseApi,
        Mod_Warehouse_Types_Options //库存类型
    } from '@/modules/server-api/wms-manage/warehouse';
    import { downloadFileTemplate, downloadExcel } from "@/utils/downloadExcel.js";
    import { WmsStockApi } from "@/modules/server-api/wms-manage/stock";
    import commondityTable from '@/modules/commodity-sys/components/commodity-table';

    import VsTable from "./vsTable/vsTable"
    import VsTd from "./vsTable/vsTd"
    import VsTh from "./vsTable/vsTh"
    import VsTr from "./vsTable/vsTr"

    import BreakUpOrder from "./components/BreakUpOrder"
    import VerifyConfirm from './components/verifyCofirm'

    import CombineOrder from './components/CombineOrder'
    import SearchInput from "@/modules/wms-manage/components/searchInput.vue";
    export default {
        components: {
            flatPickr,
            'v-select': vSelect,
            filterBox,
            addModal,
            commondityTable,
            domesticOrder,

            VsTable,
            VsTd,
            VsTh,
            VsTr,
            BreakUpOrder,
            VerifyConfirm,
            CombineOrder,
            SearchInput
        },
        computed: {
            // validDeliver(){
            //   return this.sendData.every(item => item.frtId)
            // },
            validateVerify() {
                // return (this.deliverParam.wsId !== '' && !this.deliverParam.locId !== ''  && this.deliverFlag)
                return (this.deliverParam.wsId !== '' && this.deliverParam.locId !== '' && this.deliverParam.locId !== null)
            }
        },
        mixins: [store],
        beforeRouteEnter(to, from, next) {
            console.log(from.path, '??')
            if (from.path != '/modules/order/orderDetail') {
                sessionStorage.removeItem("searchData")
                sessionStorage.removeItem("tabIndex")
                sessionStorage.removeItem("vsTabsList")
            }
            next()
        },
        data() {
            return {
                title:'海外订单详情',
                // orderTypeList:['待付款','待审核','已审核','已取消'],
                tabIndex: 0,
                tabInfo: {
                    id: 0,
                    supplierType: "全部",
                    name: "全部",
                    dealerType: ""
                },
                sendDataShow: true,
                orderSearchInfo: {}, //详情页过来的查询条件
                currentOrderNo: '', //当前要拆单的订单号
                breakUpOrderList: [], //当前拆单商品列表
                breakUpOrderShow: false, //拆单弹框
                combineOrderShow: false, //合单
                currCombineOrderInfo: {}, //当前要合单的订单
                searchData: {
                    bodyId: '', //主体名称
                    orderNo: '', // 查询的订单编号
                    fromDate: '',
                    toDate: '',
                    orderStatus: [],
                    orderWay: [],
                    buyerName: '',
                    supplierType: '', //卖家
                    dealerType: '',  //买家
                    buyerType: '',//左侧筛选条件的买家类型
                    dealerTypeList: []

                },
                validDeliver: false,
                headData: [
                  "发货单号",
        "订货单号",
        "出库单号",
        "物流商/物流单号",
        "创建日期",
        "商品信息",
        "买家/类型",
        "订单状态",
        "收件人",
        "联系方式",
        "收货地址",
        "发货仓",
        "仓位",
        "操作",
                ], // 列表头部数据
                orderdatalist: [], //订单列表
                Orderselected: [], //选中的订单
                OrderDriveselected: [],//推单选中
                OrderReviewselected: [],//选中的审核
                pageshow: true,
                page: {
                    // 分页
                    pageNo: 1,
                    pageSize: 20,
                    totalCount: 0
                },
                clickOrderNo: '',
                // tabs todo-ljm
                vsTabsList: [
                    {
                        id: 0,
                        supplierType: "全部",
                        name: "全部",
                        dealerType: "",
                        buyerType: ""
                    }
                ],
                //下单或编辑弹窗
                addPopupActive: false,
                detailDataList: {}, //详情信息
                popupActive: false, //手动下单弹窗
                isShowPopImportOrder: false, //批量导入下单弹窗
                popupActiveXzsp: false, //新增商品弹窗
                popupActiveDetail: false, //查看详情弹窗
                showDeliverPop: false, //发货
                showExchange: false, //批量换商品
                popupActive2Xck: false, //选仓库
                popupActive2Shqr: false, //审核确认
                popupActive2Qxtd: false, //取消推单
                popupActive2Qxdd: false, //取消订单
                popupActive2Qxsh: false, //取消审核
                popupActive2Bzyc: false, //标注异常
                popupActive2Sjzf: false, //手机支付
                popupActive2Zzc: false, //转正常
                radios1: 'hhh', //选择快递
                OrdermanuallyFormData: {
                    //手动下单字段
                    fromDepart: '',
                    sellerRemark: '',
                    buyerRemark: '',
                    sourceChannel: '',
                    buyer: '',
                    buyerName: '',
                    buyerType: '',
                    address: '',
                    buyerPhone: ''
                },
                OrdermanuallyArr: {
                    //手动下单下拉框数据
                    ChannelListArr: [] //渠道列表
                },
                OrderDetailArr: {
                    //订单详情下拉框数据
                    PaysListArr: [] //支付方式列表
                },
                cancelModel: '', //取消订单原因
                cancelDriveModel: '', //取消推单原因
                AbnormalModel: '', //标注异常原因
                addpaytitle: {
                    //添加手机支付的字段
                    paySource: '',
                    payTime: '',
                    payBillNo: '',
                    totalPrice: ''
                },
                TreeState: [], //订单状态数组
                TreeChannel: [], //订单状态数组
                TreeAbnormal: [], //订单状态数组
                GoaddStoreListData: [], //整个商品订单列表
                checkBox1State: [], //订单状态选择数组
                checkBox1Channel: [], //订单渠道选择数组

                judgeQxdd: '', //判断是多选删除还是反选删除
                judgeZyc: '', //判断是多选异常还是反选异常
                judgeShqr: '', //判断是多选审核确认还是反选审核确认
                addStoreselected: [], //新增商品选中的
                types: 0, //添加了几种
                addnumber: 0, //添加了几种
                totalCount: Number,

                tmsFrtOptions: [], //运费模板选项
                mainOptions: [], //主体选项
                distOptions: [], //分仓选项
                locOptions: [], //仓位选项
                deliverParam: {
                    wsId: '',
                    locId: ''
                },
                verifyConfirmId: [],
                batchFrtId: '',
                batchSelectTemplateVisible: false,
                sendData: [],
                batchSelected: [],
                stockData: [],
                stockTabledata: [], //隐藏没有发货的商品，临时存储
                skuCodes: [],
                deliverFlag: true, //是否可以发货
                sellerRemarkPop: false, //编辑卖家备注
                sellerRemark: '',
                tokenHeader: uploadHeader,
                accept: '.excel, .xlsx',
                // 物流弹框
                detailData: {},
                showDetailDialog: false,
                rowInfo: {},
                //拆单的时候需要仓库动态表头
                allStockList: [],
                searchFlag: true,
                goodsOptions: [],
                goodsOptions2: [],
                goodsExchangeOptions: [],
                oneGoodSelected: {},  //批量替换商品原商品
                selectExchange: {}, //批量替换商品替换商品
                exchangeOrderNo: [],
                currencyTypeList: [
                    { id: 'RMB', label: 'RMB', symbol: '￥' },
                    { id: 'USD', label: 'USD', symbol: '$' }
                ],
                // levelOne: ['一次性客户','内部客户','海外客户','省代PD','大零售商SCA','大连锁商SKA','CVS'],
                // levelTwo: ['地代RD','省代下级零售商CA','省代下级无店商CAN'],
                // levelThree: ['地代下级零售商CAD','地代下级无店商CAND'],
                // levelStore:[ '专卖店', '明星店', '集合店', '直营店' ],
                // levelOne: ['一次性客户','内部客户','省代PD','大零售商SCA','大连锁商SKA','CVS'],
                levelStore:[],
                levelOne: ['海外客户'],
            };
        },
        created() {
            let tabsList = sessionStorage.getItem('vsTabsList')
            if (tabsList) {
                this.vsTabsList = JSON.parse(tabsList)
                // this.orderTabChange(this.vsTabsList,this.tabIndex)
                console.log('this.tabIndex==-=2222', this.vsTabsList)
            } else {
                this.gitTabsList();
            }
        },
        mounted() {
            console.log('this.tabIndex==-=2222', this.tabIndex)
            let searchInfo = sessionStorage.getItem('searchData') //本地存储的搜索info
            this.orderSearchInfo = JSON.parse(searchInfo)  //从详情带过来的查询条件
            console.log('查询条件getItem', this.orderSearchInfo)
            this.searchData.dealerTypeList = this.levelOne.concat(this.levelStore);
            this.searchData.supplierType = '总部';
            this.getOrderformList();
            this.getPaysList();
            this.getAbnormalList();

        },
        methods: {
            goDetail(row) {
                this.$refs.domesticOrder.getData(row)
            },
            expectation() {
                //    alert('敬请期待～')
                const h = this.$createElement;
                this.$message({
                    message: h('p', null, [
                        h('span', null, '当前功能 '),
                        h('i', { style: 'color: teal' }, '敬请期待～')
                    ])
                });
            },
            // 获取tab名称列表 todo
            async gitTabsList() {
                // this.vsTabsList = []
                let all = {
                    id: 0,
                    supplierType: "全部",
                    dealerType: ""
                }
                let tabsList = this.vsTabsList;
                // 调接口赋值 todo
                let res = await OrderApi.getTabsList({});

                console.log('res----->', res.result)
                tabsList = res.result
                // 调接口赋值end todo
                tabsList.unshift(all)
                tabsList.map(tab => {
                    if (tab.dealerType == '') {
                        tab.dealerType = '下级'
                    }
                    if (tab.supplierType == '全部') {
                        tab.name = tab.supplierType
                    } else {
                        tab.name = tab.supplierType + '→' + tab.dealerType
                    }
                })
                let arr = [];
                tabsList.map(tab => {
                    if (tab.name == "总部→下级") {
                        arr.push(tab);
                    }
                })
                this.vsTabsList = arr;
                console.log(arr);
                // this.vsTabsList = tabsList
                console.log('tabsList======>', tabsList)
                console.log('this.vsTabsList', this.vsTabsList)
                sessionStorage.setItem('vsTabsList', JSON.stringify(this.vsTabsList));

            },
            createOrder() {
                //改为本地缓存，创建订单的时候清空 sessionStorage.removeItem("updateSkuItemList");
                this.$router.push({ path: '/modules/order/createOrder' })
            },
            // ========= 右侧搜索
            handleSearch(val) {
                //清空已选择的选项
                this.Orderselected = [];
                console.log('valllll------>>', val)
                this.searchData = val;
                if (this.tabInfo.supplierType === '全部') {
                    this.searchData.supplierType = ''
                } else {
                    this.searchData.supplierType = this.tabInfo.supplierType
                }
                if (this.tabInfo.dealerType === '下级') {
                    this.searchData.dealerType = ''
                } else if (this.tabInfo.dealerType === '门店') {
                    this.searchData.dealerType = ''
                } else {
                    this.searchData.dealerType = this.tabInfo.dealerType
                }

                if (val.isTab) {
                    //   this.setTabBuyerType(val);
                    this.newsetTabBuyerType(val);
                    val.buyerType = null;
                } else {
                    if (val.buyerType === '' || val.buyerType === null) {
                        //    this.setTabBuyerType(val);
                        this.newsetTabBuyerType(val);
                    } else if (val.buyerType === '门店客户') {
                        val.dealerTypeList = [val.buyerType];
                        val.buyerType = null;
                    } else {
                        val.dealerTypeList = [val.buyerType];
                        val.buyerType = null;
                    }
                }
                this.page.pageNo = 1;
                this.getOrderformList();
                this.pageshow = false;//让分页隐藏
                this.$nextTick(() => {//重新渲染分页
                    this.pageshow = true;
                });
                //   console.log('右侧搜索========this.orderSearchInfo',this.orderSearchInfo)
                //   console.log('744this.searchData',this.searchData)
            },
            setTabBuyerType(val) {
                console.log('tab 类型', val, this.tabIndex)
                let buyerType = null;
                if (this.tabIndex === 4) {
                    val.dealerTypeList = ['门店客户', '专卖店', '明星店', '集合店']
                    this.$refs.filterBox.refreshBuyerType();
                    buyerType = ['门店客户'];
                } else if (this.tabIndex === 1) {
                    val.dealerTypeList = this.levelOne.concat(this.levelStore);
                    buyerType = this.levelOne.concat(this.levelStore);
                } else if (this.tabIndex === 2) {
                    val.dealerTypeList = this.levelTwo;
                    buyerType = this.levelTwo;
                } else if (this.tabIndex === 3) {
                    val.dealerTypeList = this.levelThree;
                    buyerType = this.levelThree;
                } else {
                    val.dealerTypeList = null;
                }

                if (val.isTab) {
                    this.$refs.filterBox.refreshBuyerType(buyerType, this.tabIndex);
                }
            },
            newsetTabBuyerType(val) {
                console.log('tab 类型', val, this.tabIndex)
                let buyerType = null;
                if (this.tabIndex === 0) {
                    val.dealerTypeList = this.levelOne.concat(this.levelStore);
                    buyerType = this.levelOne.concat(this.levelStore);
                } else if (this.tabIndex === 1) {
                    val.dealerTypeList = this.levelStore;
                    buyerType = this.levelStore;
                }


                if (val.isTab) {
                    this.$refs.filterBox.refreshBuyerType(buyerType, this.tabIndex);
                }
            },
            // 切换tab
            orderTabChange(val, index) {
                console.log('切换tab -----》》', val, index)
                this.tabInfo = val;
                let info = {
                    bodyId: this.searchData.bodyId,
                    orderNo: this.searchData.orderNo, // 查询的订单编号
                    fromDate: this.searchData.fromDate,
                    toDate: this.searchData.toDate,
                    orderStatus: this.searchData.orderStatus,
                    orderWay: this.searchData.orderWay,
                    supplierType: this.searchData.supplierType, //卖家
                    dealerType: this.searchData.dealerType === '门店' ? '' : this.searchData.dealerType,  //买家
                    buyerType: this.searchData.buyerType, //左侧筛选的买家类型
                    buyer: this.searchData.buyer, //左侧筛选的买家
                    dealerTypeList: this.searchData.dealerTypeList,
                }
                sessionStorage.setItem('tabIndex', this.tabIndex);
                sessionStorage.setItem('searchData', JSON.stringify(info))
                if (index !== 0) {
                    info.supplierType = val.supplierType; //卖家
                    console.log('查询数据', val.dealerType, val.dealerType === '门店');
                    if (val.dealerType === '门店') {
                        info.dealerType = '' //买家
                    } else {
                        info.dealerType = val.dealerType === '下级' ? '' : val.dealerType //买家
                    }
                } else {
                    info.supplierType = '';
                    info.dealerType = ''
                }
                info.isTab = true;
                console.log('查询数据', info);
                //清空左侧筛选条件
                // this.$refs.filterBox.emptyOrderSearch()
                this.handleSearch(info)
            },
            //导入文件
            uploadSuccess(response, file, fileList) {
                console.log('uploadSuccess');
                if (response.succ == 1 && response.code != $busErrorCode) {
                    this.isShowPopImportOrder = false;
                    this.$notifySuccess("导入成功")
                    this.getOrderformList();
                } else {
                    this.$notifyError(response.error || '导入数据格式错误,请修改后重新上传');
                }
            },

            //获取物流信息
            async getDetail(row) {
                console.log('rowwww', row.billSendBo.expressProvider)
                this.showDetailDialog = true;
                let { orderNo } = row;

                console.log(row);
                let resp = await OrderApi.getOrderFollowInfo({
                    orderNo,
                });
                this.detailData = resp.result || {
                    // expressName: row.billSendBo.expressProvider || '',
                    transitNo: '',
                    receiveAddress: '',
                    traces: []
                };
                console.log('this.detailData', this.detailData)
                this.detailData.expressName = row.billSendBo.expressProvider || this.detailData.expressName || ''
            },
            // 单个选择运费模板
            sendFrtIdChange() {
                this.sendDataShow = false;//让分页隐藏
                this.$nextTick(() => {//重新渲染分页
                    this.sendDataShow = true;
                })

            },
            getTime(type, value) {
                let arr = value.split(' ');
                return type === 'day' ? arr[0] : arr[1];
            },
            //锁定订单
            lockOrderConfirm(tr, indextr, isLock) {
                let lockTitle = '您确认' + (isLock ? '' : '取消') + '锁定该订单吗？';
                let lockBtnText = isLock ? '锁定' : '取消锁定';
                this.$vs.dialog({
                    type: "confirm",
                    title: `操作提示`,
                    text: lockTitle,
                    acceptText: lockBtnText,
                    cancelText: "取消",
                    accept: () => {
                        this.lockOrder(tr, indextr, isLock);
                    }
                });
            },
            //锁定订单
            async lockOrder(tr, index, isLock) {
                this.$vs.loading()
                let sendIds = []
                if (index === undefined) {
                    if (this.Orderselected.length == 0) {
                        return this.$notifyError('请选择订单');
                    }
                    //校验是否是总部可操作的状态
                    if (!this.getExtraOrder()) {
                        return false;
                    }
                    const temp = this.Orderselected.every(item => item.orderStatus !== 'TO_SEND');
                    if (temp) {
                        return this.$notifyError('选择的订单中有不可锁定的订单，请重新选择');
                    }
                    sendIds = this.Orderselected.map(item => item.orderNo)
                } else {
                    this.clickOrderNo = tr.orderNo
                    sendIds = [tr.orderNo];
                }
                //锁定
                let resp;
                if (isLock) {
                    resp = await OrderApi.lockOrder({
                        orderNos: sendIds
                    });
                } else {
                    resp = await OrderApi.cancelLockOrder({
                        orderNos: sendIds
                    });
                }

                this.$vs.loading.close();
                if (resp.succ == 1) {
                    this.popupActiveLock = false;
                    let successText = isLock ? '锁定成功' : '取消锁定成功';
                    this.$notifySuccess(successText);
                    this.getOrderformList();
                } else {
                    this.$notifyError(resp.error);
                    this.popupActiveLock = false;
                }
            },
            // 确认取消
            cancelAffirm(tr, indextr) {
                this.$vs.dialog({
                    type: "confirm",
                    title: `实付与成交金额不同，请确认是否继续审核：`,
                    text: `金额不同继续审核，订单将会转异常`,
                    acceptText: "继续审核",
                    cancelText: "取消",
                    accept: () => {
                        this.verifyConfirm(tr, indextr);
                    },
                });
            },
            // ========================== 表头多选操作
            // 判断金额实付与订单总金额是否一致
            priceCompare(tr, indextr) {
                console.log('trrrrr', tr)
                if (tr.orderNo) {
                    const temp = this.orderdatalist.filter(item => item.orderNo == tr.orderNo)
                    if (temp) {
                        console.log('temp----', temp)
                        if (temp[0].dealTotalPrice != temp[0].actualTotalPrice) {
                            return this.cancelAffirm(tr, indextr)
                        } else {
                            this.verifyConfirm(tr, indextr);
                        }
                    }
                }
            },
            // 审核确认
            async verifyConfirm(tr, index) {
                // console.log('trrrrr',tr)
                // if (tr.orderNo) {
                //      const temp = this.orderdatalist.filter(item => item.orderNo == tr.orderNo)
                //     if (temp) {
                //         console.log('temp----',temp)
                //         if (temp[0].dealTotalPrice != temp[0].actualTotalPrice) {
                //           return this.cancelAffirm()
                //         }
                //     }
                // }
                this.$vs.loading()
                let sendIds = []
                if (index === undefined) {
                    if (this.Orderselected.length == 0) {
                        return this.$notifyError('请选择订单');
                    }
                    //校验是否是总部可操作的状态
                    if (!this.getExtraOrder()) {
                        return false;
                    }
                    const temp = this.Orderselected.every(item => item.orderStatus !== 'TO_REVIEW');
                    if (temp) {
                        return this.$notifyError('选择的订单中有不可审核的订单，请重新选择');
                    }
                    sendIds = this.Orderselected.map(item => item.orderNo)
                } else {
                    this.clickOrderNo = tr.orderNo
                    sendIds = [tr.orderNo];
                }
                this.verifyConfirmId = sendIds
                //清空
                this.deliverParam = {
                    wsId: '',
                    locId: ''
                }
                this.skuCodes = [];
                this.stockData = [];
                await this.getMainList();
                await this.handleReviewDetail(sendIds)
                this.judgeShqr = false;
                this.popupActive2Shqr = true;
                this.$vs.loading.close()
            },
            //判断单据是否有非总部
            getExtraOrder() {
                const extraOrder = this.Orderselected.every(item => !item.sellerIsMe);
                let flag = true;
                if (extraOrder) {
                    this.$notifyError('存在总部不可操作的订单，请重新选择');
                    flag = false;
                }
                return flag;
            },
            // 取消审核
            cancelVerifyConfirm(tr) {
                console.log('trtrtrtr', tr)
                this.OrderReviewselected = tr;
                this.popupActive2Qxsh = true;
            },
            async handleReviewDetail(sendIds) {
                const res = await OrderApi.reviewDetail({ orderNos: sendIds })
                if (res.succ === 1) {
                    this.stockData = res.result
                    this.stockData = res.result.map(item => {
                        return {
                            ...item,
                            newSendSkuName: '',
                            newSendAmount: ''
                        }
                    })
                    this.stockTabledata = this.stockData;
                    this.skuCodes = this.stockData.map(item => {
                        return item.skuCode;
                    });
                }
            },
            // 取消推单
            cancelDriveOrder(tr) {
                this.OrderDriveselected = tr;
                console.log('tr12121212', tr)
                if (this.OrderDriveselected.length == 0) {
                    return this.$notifyError('请选择订单');
                }
                this.popupActive2Qxtd = true;
            },
            // 取消订单
            cancelOrder(tr, index) {
                if (index === undefined) {
                    if (this.Orderselected.length == 0) {
                        return this.$notifyError('请选择订单');
                    }
                    //校验是否是总部可操作的状态
                    if (!this.getExtraOrder()) {
                        return false;
                    }
                    const temp = this.Orderselected.filter(item => item.orderStatus === 'SEND_ED' || item.orderStatus === 'RECEIV_ED' || item.orderStatus === 'ABNORMAL');
                    if (temp.length) {
                        return this.$notifyError('选择的订单中有不可取消的订单，请重新选择');
                    }
                } else {
                    this.clickOrderNo = tr.orderNo;
                }
                this.popupActive2Qxdd = true;
                this.judgeQxdd = false;
            },
            // 转异常
            toAbnormal(tr, index) {
                if (index === undefined) {
                    if (this.Orderselected.length == 0) {
                        return this.$notifyError('请选择订单');
                    }
                    //校验是否是总部可操作的状态
                    if (!this.getExtraOrder()) {
                        return false;
                    }
                    //不可转异常的订单
                    let disabledList = ['SEND_ED', 'RECEIV_ED', 'CANCEL_ED', 'ABNORMAL']
                    const temp = this.Orderselected.some(item => disabledList.indexOf(item.orderStatus) !== -1);
                    if (temp) {
                        return this.$notifyError('存在不支持此类型操作的订单');
                    }

                    let orderTypes = Array.from(new Set(this.Orderselected.map(item => item.orderStatus)))
                    if (orderTypes.length > 1) {
                        return this.$notifyError('存在不同状态的订单，不能统一执行此类型操作');
                    }
                } else {
                    this.clickOrderNo = tr.orderNo;
                }
                this.judgeZyc = false;
                this.popupActive2Bzyc = true;
            },
            // 转正常
            toNormal(tr, index) {
                console.log(tr, index);
                if (index === undefined) {
                    if (this.Orderselected.length == 0) {
                        return this.$notifyError('请选择订单');
                    }
                    //校验是否是总部可操作的状态
                    if (!this.getExtraOrder()) {
                        return false;
                    }
                    const temp = this.Orderselected.some(item => item.orderStatus !== 'ABNORMAL');
                    if (temp) {
                        return this.$notifyError('请选择异常订单');
                    }
                } else {
                    this.clickOrderNo = tr.orderNo;
                }
                this.popupActive2Zzc = true;
            },

            // ============================ 列表相关
            //更改每页条数
            handleSizeChange(val) {
                this.page.pageSize = val;
                this.getOrderformList();
            },
            handleCurrentChange(val) {
                this.page.pageNo = val;
                this.getOrderformList();
            },
            //订货单列表查询
            async getOrderformList() {
                console.log(this.searchData)
                this.$vs.loading();
                let data = {}
                let searchInfo = sessionStorage.getItem('searchData') //本地存储的搜索info
                this.orderSearchInfo = JSON.parse(searchInfo)  //从详情带过来的查询条件
                //   判断是否从详情页返回，如果是就保留之前查询条件
                // if (this.orderSearchInfo) {
                //     data = {
                //         pageNo: this.page.pageNo,
                //         pageSize: this.page.pageSize,
                //         data: {
                //             sourceChannelList: this.orderSearchInfo.orderWay,
                //             startTime: this.orderSearchInfo.fromDate,
                //             endTime: this.orderSearchInfo.toDate,
                //             orderStatusList: this.orderSearchInfo.orderStatus,
                //             orderNo: this.orderSearchInfo.orderNo,
                //             buyer: this.orderSearchInfo.buyer, //买家名称
                //             buyerType: '',  //买家类型
                //             supplierType: this.searchData.supplierType,  //买家类型
                //             dealerType: this.searchData.dealerType,  //买家类型
                //             dealerTypeList: this.searchData.dealerTypeList
                //         }
                //     };
                // } else {
                    data = {
                        pageNo: this.page.pageNo,
                        pageSize: this.page.pageSize,
                        data: {
                            sourceChannelList: this.searchData.orderWay,
                            startTime: this.searchData.fromDate,
                            endTime: this.searchData.toDate,
                            orderStatusList: this.searchData.orderStatus,
                            orderNo: this.searchData.orderNo,
                            buyer: this.searchData.buyer, //买家名称
                            buyerType: this.searchData.buyerType,  //买家类型
                            supplierType: this.searchData.supplierType,  //买家类型
                            dealerType: this.searchData.dealerType,  //买家类型
                            dealerTypeList: this.searchData.dealerTypeList
                        }
                    }
                // }
                console.log('789', this.searchData.orderWay)
                 // 改用发货单接口
                // let res = await OrderApi.OrderformList(data);
                let res = await OrderApi.OrderInvoList(data);
                //增加币种
                let resData = res.result.list;
                if (resData.length) {
                    resData = resData.map(data => {
                        let currSku = data.skuItems;
                        if (currSku.length > 0) { //获取金额标识符
                            let currCurrency = data.skuItems ? data.skuItems[0].currency : this.currencyTypeList[0].id;
                            let cIndex = this.currencyTypeList.findIndex(item => item.id == currCurrency);
                            data.currency = cIndex > -1 ? currCurrency : this.currencyTypeList[0].id;
                            cIndex = cIndex > -1 ? cIndex : 0;
                            data.currencySymbol = this.currencyTypeList[cIndex].symbol;
                        }
                        return data;
                    });
                }
                this.orderdatalist = resData;
                this.page.totalCount = res.result.totalCount;
                this.$vs.loading.close();
            },
            orderThStyle(thname) {
                let style = ''
                if (thname == "实付" || thname == "应付") {
                    style = 'price-right'
                } else if(thname == "操作"){
                    style = 'fixed-table-column whit'
                }
                return style;
            },
            orderStatusColorStyle(status) {
                const statusMaps = [
                    {
                        key: 'TO_PAY',
                        style: 'background: #A1A7B4'
                    },
                    {
                        key: 'TO_REVIEW',
                        style: 'background: #FF8D23'
                    },
                    {
                        key: 'TO_SEND',
                        style: 'background: #9254DE'
                    },
                    {
                        key: 'SEND_ED',
                        style: 'background: #3691FF'
                    },
                    {
                        key: 'PUSHED',
                        style: 'background: #5CDBD3'

                    },
                    {
                        key: 'RECEIV_ED',
                        style: 'background: #2DC44B'
                    },
                    {
                        key: 'CANCEL_ED',
                        style: 'background: #A1A7B4'
                    },
                    {
                        key: 'SPLIT_ORDER',
                        style: 'background: #A1A7B4'
                    },
                    {
                        key: 'ABNORMAL',
                        style: 'background: #FF433D'
                    },
                    {
                        key: 'COMBINE_ED',
                        style: 'background: #A1A7B4'
                    }
                ]
                // const statusInfo =  this.orderStatusList.find(item => item.value === status)
                const map = statusMaps.find(item => item.key === status)
                if (map) {
                    return map.style
                }
            },

            // 点击编辑
            handleEdit(str, index) {
                // this.addPopupActive = true
                // this.detailDataList = str
            },
            // 查看
            handleCheck(str, index, editFlag) {
                // this.addPopupActive = true
                // this.detailDataList = str
                sessionStorage.setItem('detail', JSON.stringify(str));
                sessionStorage.setItem('editFlag', editFlag);
                console.log("editFlag===", editFlag);
                // console.log("str===", str);
                // console.log("index===", index);
                // this.$emit("getSearchInfo"deta,deta);
                this.$router.push({ path: '/modules/order/orderDetail' }).catch(() => { });
                // this.$router.push({ name: 'order-management-detail' ,params:deta}).catch(() => {});
            },

            // 弹窗相关
            // 关闭查看。编辑弹窗
            close() {
                this.addPopupActive = false;
            },

            //渠道列表
            async getChannelList() {
                let res = await OrderApi.ChannelList({});
                this.OrdermanuallyArr.ChannelListArr = res.result;
                this.TreeChannel = res.result;
                // console.log('123',this.OrdermanuallyArr.ChannelListArr)
            },
            //支付方式
            async getPaysList() {
                let res = await OrderApi.PaysList({});
                this.OrderDetailArr.PaysListArr = res.result;
            },

            //异常标注类型列表
            async getAbnormalList() {
                let res = await OrderApi.AbnormalList({});
                this.TreeAbnormal = res.result;
            },
            // 取消推单确认
            async OncancelDriveOrder() {
                // this.popupActive2Qxtd = false;
                let orderNos = [];
                console.log('this.OrderDriveselected', this.OrderDriveselected.orderNo)
                orderNos.push(this.OrderDriveselected.orderNo)
                //取消订单原因
                let res = await LogisticsApi.cancelDriveOrderChoice({
                    orderNos: orderNos,
                    cancelReason: this.cancelDriveModel
                });
                if (res.succ == 1) {
                    this.popupActive2Qxtd = false;
                    this.$notifySuccess('取消成功');
                    // this.getTableData();

                } else {
                    this.$notifyError(res.error);
                    this.popupActive2Qxtd = false;
                }
                this.OrderDriveselected = [];
                this.cancelDriveModel = '';
                this.getOrderformList();
            },
            // 取消推单取消
            OncancelDrivebtn() {
                this.popupActive2Qxtd = false;

            },
            // 取消审核确认
            async OncancelAuditOrder() {
                this.popupActive2Qxsh = false;
                let orderNo = this.OrderReviewselected.orderNo;
                let resp = await OrderApi.onfirmOrderReview({
                    orderNo
                });
                if (resp.succ == 1) {
                    this.popupActive2Qxsh = false;
                    this.$notifySuccess('取消成功');
                    this.getOrderformList();
                } else {
                    this.$notifyError(resp.error);
                    this.popupActive2Qxsh = false;
                }

                //   this.getOrderformList();
            },
            // 取消审核取消
            OncancelAuditbtn() {
                this.popupActive2Qxsh = false;
            },
            //取消订单
            async OncancelOrder() {
                let orderNos = [];
                if (!this.clickOrderNo) {
                    this.Orderselected.map(item => {
                        orderNos.push(item.orderNo);
                        return item;
                    });
                } else {
                    orderNos.push(this.clickOrderNo);
                }
                let res = await OrderApi.cancelOrderChoice({
                    orderNos: orderNos,
                    warnMessage: this.cancelModel
                });
                if (res.succ == 1) {
                    this.popupActive2Qxdd = false;
                    this.$notifySuccess('取消成功');
                    // this.getTableData();
                } else {
                    this.$notifyError(res.error);
                    this.popupActive2Qxdd = false;
                }
                this.clickOrderNo = '';
                this.Orderselected = [];
                this.getOrderformList();
            },

            //取消取消订单
            Oncancelbtn() {
                this.clickOrderNo = '';
                this.popupActive2Qxdd = false;
            },
            //添加手工支付
            async OnOrderAddPay() {
                if (this.addpaytitle.paySource == '' || this.addpaytitle.payTime == '' || this.addpaytitle.payBillNo == '' || this.addpaytitle.totalPrice == '') {
                    this.$notifyError('请将数据填写完整');
                    return;
                }
                let res = await OrderApi.OrderAddPay({
                    orderNo: this.detailDataList.orderNo,
                    paySource: this.addpaytitle.paySource,
                    payTime: this.addpaytitle.payTime + ` 00:00:00`,
                    payBillNo: this.addpaytitle.payBillNo,
                    totalPrice: this.addpaytitle.totalPrice
                });
                if (res.succ == 1) {
                    this.popupActive2Sjzf = false;
                    this.$notifySuccess('添加手工支付成功');
                    // this.detailDataList.orderNo=''
                    // this.addpaytitle.paySource=''
                    // this.addpaytitle.payTime=''
                    // this.addpaytitle.payBillNo=''
                    // this.addpaytitle.totalPrice=''
                    // this.getTableData();
                } else {
                    this.$notifyError(res.error);
                    this.popupActive2Sjzf = false;
                }
            },

            //订单审核确认
            async OnconfirmOrder() {
                let orderNos = [];
                if (!this.clickOrderNo) {
                    orderNos = this.Orderselected.map(item => {
                        return item.orderNo;
                    });
                } else {
                    orderNos.push(this.clickOrderNo);
                }
                const params = {
                    orderNos,
                    wsId: this.deliverParam.wsId,
                    locId: this.deliverParam.locId,
                }
                const res = await OrderApi.batchReview(params)
                if (res.succ === 1) {
                    this.$notifySuccess('审核成功');
                } else {
                    this.$notifyError(res.error);
                }
                this.popupActive2Shqr = false;
                this.clickOrderNo = '';
                this.Orderselected = [];
                this.getOrderformList();
            },

            //点击转异常
            iconabnormal() {
                this.judgeZyc = true;
                this.popupActive2Bzyc = true;
            },

            //确认转异常
            async OnOrderAbnormal() {
                console.log('this.Orderselected', this.Orderselected)
                console.log('this.this.clickOrderNo', this.clickOrderNo)
                let orderNos = [];
                if (!this.clickOrderNo) {
                    this.Orderselected.map(item => {
                        orderNos.push(item.orderNo);
                        return item;
                    });
                } else {
                    orderNos.push(this.clickOrderNo);
                }
                let TreeAbnormal = this.TreeAbnormal
                const AbnormalModel = TreeAbnormal.filter(item => {
                    if (item.key == this.AbnormalModel) {
                        return item
                    }
                })
                console.log('orderNos', orderNos)
                console.log('AbnormalModel', AbnormalModel)
                let res = await OrderApi.OrderAbnormalChoice({
                    orderNos: orderNos,
                    warnMessage: AbnormalModel[0].val   //转异常描述
                    // warnMessage: AbnormalModel[0].key  //转异常编码
                });
                if (res.succ == 1) {
                    this.popupActive2Bzyc = false;
                    this.AbnormalModel = ''
                    this.$notifySuccess('标注成功');
                } else {
                    this.AbnormalModel = ''
                    orderNos = []
                    this.$notifyError(res.error);
                    this.popupActive2Bzyc = false;
                }
                this.clickOrderNo = ''
                this.Orderselected = [];
                this.getOrderformList();
                return;
            },
            //取消转异常
            OrderAbnormalbtn() {
                this.popupActive2Bzyc = false;
            },
            // 确认转正常
            async OnNormalOk() {
                let orderNos = [];
                if (!this.clickOrderNo) {
                    this.Orderselected.map(item => {
                        orderNos.push(item.orderNo);
                        return item;
                    });
                } else {
                    orderNos.push(this.clickOrderNo);
                }
                let res = await OrderApi.OrderTonormal({
                    orderNos: orderNos
                });
                if (res.succ == 1) {
                    this.$notifySuccess('转正常成功');
                } else {
                    this.$notifyError(res.error);
                }
                this.popupActive2Zzc = false;
                this.clickOrderNo = '';
                this.Orderselected = [];
                this.getOrderformList();
            },
            //取消转正常
            normalbtn() {
                this.popupActive2Zzc = false;
            },
            // 调接口获取发货弹窗详情
            async getSentDetail(sendIds) {
                const res = await OrderApi.queryDeliveryOrder({ orderNos: sendIds })
                if (res.succ === 1) {
                    this.sendData = res.result
                }
            },
            // ----------------------------发货相关
            // 批量选择运费模板
            batchSelectTemplate() {
                this.batchSelectTemplateVisible = true
            },
            handleBatchSelect() {
                this.batchSelected = this.batchSelected.map(item => {
                    item.frtId = this.batchFrtId
                    const currIndex = this.sendData.findIndex(selected => selected.locName == item.locName && selected.wsName == item.wsName);
                    this.$set(this.sendData, currIndex, { ...this.sendData[currIndex], frtId: this.batchFrtId });
                    return item;
                })
                this.batchFrtId = ''
                this.batchSelectTemplateVisible = false
            },
            cancelhandleBatch() {
                this.batchFrtId = ''
                this.batchSelectTemplateVisible = false
            },
            //发货
            async handleSend(tr, index) {
                console.log('tr--------批量推单', tr, index);
                let sendIds = []
                this.getTmsFrtOptions();
                if (index === undefined) {
                    if (this.Orderselected.length == 0) {
                        return this.$notifyError('请选择订单');
                    }
                    //校验是否是总部可操作的状态
                    if (!this.getExtraOrder()) {
                        return false;
                    }
                    const temp = this.Orderselected.some(item => item.orderStatus !== 'TO_SEND');
                    if (temp) {
                        return this.$notifyError('请选择待发货订单');
                    }
                    const sellerIsMe = this.Orderselected.some(item => !item.sellerIsMe);
                    if (sellerIsMe) {
                        return this.$notifyError('请选择总部待发货订单');
                    }
                    sendIds = this.Orderselected.map(item => item.orderNo)
                    console.log('sendIds', sendIds)
                } else {
                    sendIds = [tr.orderNo];
                }
                this.getSentDetail(sendIds)
                this.batchSelected = []
                this.showDeliverPop = true;
            },
            // 批量换商品 todo
            handleExchange(tr, index) {
                //   let sendIds = []
                this.exchangeOrderNo = []
                if (index === undefined) {
                    if (this.Orderselected.length == 0) {
                        return this.$notifyError('请选择订单');
                    }
                    //校验是否是总部可操作的状态
                    if (!this.getExtraOrder()) {
                        return false;
                    }
                    const temp = this.Orderselected.some(item => item.orderStatus !== 'TO_REVIEW');
                    if (temp) {
                        return this.$notifyError('请选择待审核订单');
                    }
                    // 待审核订单中仅下单给总部的订单 todo
                    const sellerIsMe = this.Orderselected.some(item => !item.sellerIsMe);
                    if (sellerIsMe) {
                        return this.$notifyError('请选择总部订单');
                    }
                    this.exchangeOrderNo = this.Orderselected.map(item => item.orderNo)
                    console.log('this.exchangeOrderNo', this.exchangeOrderNo)
                } else {
                    this.exchangeOrderNo = [tr.orderNo];
                }
                this.showExchange = true;

            },
            //模糊搜索获取sku信息
            async searchInputSuggest(value) {
                this.$refs['commodityExchangeSuggest'].searchQuery = '';
                if (value != "") {
                    let res = await CommodityGoodsyApi.suggestSkuGoods({ key: value });
                    this.goodsOptions = res.result;
                    console.log('this.goodsOptions', this.goodsOptions)
                } else {
                    this.goodsExchangeOptions = []
                }
            },
            // 替换商品的goodsOptions
            async exchangeInputSuggest(value) {
                //  console.log('value',value)
                if (value == "") {
                    this.selectExchange = {}
                    this.$refs['commodityExchangeSuggest'].searchQuery = '';
                    // return this.$notifyError('请输入替换商品');
                } else {
                    let res = await CommodityGoodsyApi.suggestSkuGoods({ key: value });
                    this.goodsOptions2 = res.result;
                    const list = this.goodsOptions2.filter(good => good.skuCode != this.oneGoodSelected.skuCode)
                    if (list.length > 0) {
                        this.goodsExchangeOptions = list;
                    }
                }
            },
            //选择原商品
            selectOneGood(item) {
                console.log("===selectOneGood===", item);
                console.log("===this.goodsOptions2===", this.goodsOptions2);
                this.oneGoodSelected = item;
                // const list = this.goodsOptions2.filter(good => good.skuCode != item.skuCode)
                // if (list.length > 0) {
                //     this.goodsExchangeOptions =list;
                // }
            },
            //选择替换商品
            selectExchangeGood(item) {
                console.log("===selectExchangeGood===", item);
                this.selectExchange = item;
            },
            // 批量换商品
            async commodityExchange() {
                console.log('原商品', this.oneGoodSelected)
                console.log('替换商品', this.selectExchange)
                if (this.oneGoodSelected.skuCode == null) {
                    return this.$notifyError('请输入原商品');
                }
                if (this.selectExchange.skuCode == null) {
                    return this.$notifyError('请输入替换商品');
                }
                let list = {
                    skuCode: this.oneGoodSelected.skuCode,
                    skuCodeNew: this.selectExchange.skuCode,
                    orderNos: this.exchangeOrderNo
                }
                const res = await OrderApi.exchangeGood(list)
                if (res.succ === 1) {
                    this.$notifySuccess('替换成功');
                    this.oneGoodSelected = {}
                    this.selectExchange = {}
                    this.$refs['commoditySuggest'].searchQuery = '';
                    this.$refs['commodityExchangeSuggest'].searchQuery = '';
                    this.showExchange = false;
                } else {
                    // this.oneGoodSelected = {}
                    // this.selectExchange = {}
                    // this.$refs['commoditySuggest'].searchQuery ='';
                    // this.$refs['commodityExchangeSuggest'].searchQuery ='';
                    this.$notifyError(res.error);
                    // this.showExchange = false;
                }
                this.getOrderformList();

            },
            //
            cancelExchange() {
                this.oneGoodSelected = {}
                this.selectExchange = {}
                this.$refs['commoditySuggest'].searchQuery = '';
                this.$refs['commodityExchangeSuggest'].searchQuery = '';
                this.showExchange = false;
            },
            // 确认推单
            async deliverOrder() {
                const list = this.sendData.map(item => ({ orderNo: item.orderNo, frtId: item.frtId }))
                console.log('list========', list)
                const res = await OrderApi.batchOrderSend({ list })
                if (res.succ === 1) {
                    this.$notifySuccess('推单成功');
                    this.sendData = []
                    this.Orderselected = []
                } else {
                    this.sendData = []
                    this.Orderselected = []
                    this.$notifyError(res.error);
                }
                this.getOrderformList();
            },
            // 取消
            cancelDeliverOrder() {
                this.showDeliverPop = false
                this.sendData = []
                // this.Orderselected = []
            },
            //拆单
            async handleSeparateBill(tr, index) {
                let list = []
                let currSkuItems = []
                let orderNos = []
                orderNos.push(tr.orderNo)
                let data = {
                    orderNos: orderNos
                }
                //获取拆单列表
                let res = await OrderApi.getBatchOrderSplit(data);
                if (res.succ == 1) {
                    // this.$notifySuccess('成功');
                    console.log('resres----res', res.result[0].skuItems)
                    currSkuItems = res.result[0].skuItems; //订单商品
                } else {
                    this.$notifyError(res.error);
                }
                let separator = '/';
                //获取总的仓库集合
                this.allStockList = [];
                let tTllStockList = [];
                currSkuItems.map(currSku => {
                    currSku.skuNameCounts.map(currSku => {
                        if (currSku.wmsStockInfos.length > 0) {
                            currSku.wmsStockInfos.map(stock => {
                                //存储仓库总集合
                                const stockIndex = tTllStockList.findIndex(ss => ss.wsName == stock.wsName && ss.locName == stock.locName);
                                if (stockIndex == -1) {
                                    const index = tTllStockList.length;
                                    tTllStockList.push({
                                        id: 'stock' + index,
                                        wsName: stock.wsName,
                                        locName: stock.locName,
                                        title: (stock.wsName || '') + (stock.locName || '')
                                    });
                                }
                            });
                        }
                    })
                });
                this.allStockList = tTllStockList;
                //格式化数据
                let formatSkuItems = [];
                currSkuItems.map(item => {
                    let addSku = {};
                    addSku.barCode = item.barCode;
                    addSku.skuCode = item.skuCode;
                    addSku.skuName = item.skuName;
                    addSku.num = item.num;
                    addSku.orderType = item.orderType;
                    //箱规
                    addSku.boxSpec = item.boxSpec;
                    //下单数量
                    addSku.orderNum = item.num + item.unit || '';
                    let skuStockNum = 0;
                    //是否合并单元格
                    let tempSpanFlag = item.skuNameCounts.length > 1 ? true : false;
                    //存储第二行盒的数据
                    let avaTotalStockCount = 0;//可用总库存
                    let actualTotalStockCount = 0;//实际总库存

                    let secondItem = JSON.parse(JSON.stringify(addSku));
                    item.skuNameCounts.map((sku, skuIndex) => {
                        tTllStockList.map(cStock => {
                            //组装箱数据
                            const stockIndex = sku.wmsStockInfos.findIndex(ws => ws.wsName == cStock.wsName && ws.locName == cStock.locName);
                            const tempId = cStock.id;
                            if (stockIndex == -1) {
                                if (skuIndex == 0) {
                                    addSku[tempId] = '-';
                                } else {
                                    secondItem[tempId] = '-';
                                }

                            } else {
                                let tempStock = sku.wmsStockInfos[stockIndex];
                                //箱可用库存/实际库存
                                skuStockNum = tempStock.availableAmount || 0;
                                const actAmount = tempStock.actualAmount || 0;
                                let showStock = skuStockNum + separator + actAmount;
                                //计算总库存
                                avaTotalStockCount += Number(skuStockNum);
                                actualTotalStockCount += Number(actAmount);
                                //判断仓库颜色
                                // const stockClass = tempId + 'Class';
                                // let isFit = false;
                                // if(Number(skuStockNum) >= Number(tempStock.availableAmount)){
                                //   isFit = true;
                                // }
                                if (skuIndex == 0) {
                                    addSku[tempId] = showStock;
                                    // addSku[stockClass] = isFit;
                                } else {
                                    secondItem[tempId] = showStock;
                                    // secondItem[stockClass] = isFit;
                                }
                            }
                        });

                        //总库存
                        const totalStockCount = avaTotalStockCount + separator + actualTotalStockCount;
                        if (skuIndex == 0) {
                            addSku.unit = sku.unit;
                            addSku.allStockNum = totalStockCount;
                            addSku.sendSkuBarCode = sku.barCode || '';
                            addSku.sendSkuName = sku.skuName; //发货名称
                            addSku.sendNum = sku.count || 0;
                            addSku.sendSpecNum = sku.count ? (sku.count + (sku.unit || '')) : ''; //发货数量
                        } else {
                            secondItem.unit = sku.unit;
                            secondItem.allStockNum = totalStockCount;
                            secondItem.sendSkuBarCode = sku.barCode || '';
                            secondItem.sendSkuName = sku.skuName; //发货名称
                            secondItem.sendNum = sku.count || 0;
                            secondItem.sendSpecNum = sku.count ? (sku.count + (sku.unit || '')) : ''; //发货数量
                        }
                    });

                    //是否合并单元格
                    addSku.spanFlag = tempSpanFlag;
                    if (addSku.spanFlag) {
                        addSku.split = 1;
                        secondItem.split = 2;

                        formatSkuItems.push(addSku);
                        formatSkuItems.push(secondItem);

                    } else {
                        addSku.split = 0;
                        // addSku.sendSkuName = item.skuName; //发货名称
                        // addSku.sendSkuBarCode = item.barCode;
                        formatSkuItems.push(addSku);
                    }
                })
                this.breakUpOrderList = JSON.parse(JSON.stringify(formatSkuItems))
                this.currentOrderNo = tr.orderNo;

                // console.log('===allStockList===', this.allStockList);
                console.log('===formatSkuItems===', formatSkuItems);
                this.breakUpOrderShow = true;
            },
            /* 仓位库存颜色判断逻辑：
             * 需求：判断每个仓位可用库存是否大于发货数量，如果仓位库存大于/等于发货数量，显示绿色；
             * 逻辑：库存是否充足判断：（如发货数量5箱10盒）
             *  箱库存大于等于发货数量的箱（即>= 5） && 盒库存大于等于发货数量的盒（即>=10）
             * 如果小于，显示黑色；
             * sendSku: 发货箱数量
             * sendSkuBox: 发货盒数量
             * skuStock: 当前仓位箱库存
             * skuBoxStock: 当前仓位盒库存
             * boxSpec: 箱规
             */
            currStockFit(sendSku, sendSkuBox, skuStock, skuBoxStock, boxSpec) {
                console.log('sendSku, sendSkuBox, skuStock, skuBoxStock',
                    sendSku, sendSkuBox, skuStock, skuBoxStock)
                let fitFlag = false;
                if (Number(skuStock) >= Number(sendSku) && Number(skuBoxStock) >= Number(sendSkuBox)) {
                    fitFlag = true;
                }
                return fitFlag;
            },
            //合并订单
            handleCombineBill(tr, index) {
                // console.log('==combineOrder==combineOrder====',this.$refs.combineOrder);
                this.combineOrderShow = true;
                this.currCombineOrderInfo = tr;
                console.log('this.$refs.combineOrder===', this.$refs.combineOrder);
                // this.$refs.combineOrder.checkedType = [];
                // this.$refs.combineOrder.searchCanComineList();
            },
            //获取主体
            async getMainList() {
                let resp = await WmsWarehouseApi.getAllMainBody({});
                console.log(resp);
                if (resp.code == 0 && resp.succ == 1) {
                    let result = resp.result;
                    this.mainOptions = result.map(item => {
                        let obj = {};
                        obj.id = item.id;
                        obj.label = item.name;
                        return obj;
                    });
                }
            },
            //获取分仓
            async getMainOptions(id, flag) {
                let bodyId = id || this.deliverParam.bodyId;
                if (bodyId == '') {
                    this.$notifyError('请先选择主体');
                } else {
                    let resp = await WmsWarehouseApi.getWarehouseAll({
                        bodyId: bodyId,
                        suggest: '',
                        type: Mod_Warehouse_Types_Options[2].id
                    });
                    this.distOptions = resp.result.map(item => {
                        let obj = {};
                        obj.id = item.wsId;
                        obj.label = item.wsName;
                        return obj;
                    });
                    if (!flag) {
                        this.$set(this.deliverParam, 'wsId', '')
                        this.$set(this.deliverParam, 'locId', '')
                    }
                }
            },
            //获取仓位
            async getLocOptions(id, flag) {
                let wsId = id || this.deliverParam.wsId;
                this.deliverParam.locId = '';
                if (wsId == '') {
                    this.$notifyError('请先选择仓库');
                } else {
                    let resp = await WmsWarehouseApi.getLocAll({
                        wsId: wsId
                    });
                    this.locOptions = resp.result
                        ? resp.result.map(item => {
                            let obj = {};
                            obj.id = item.id;
                            obj.label = item.locName;
                            return obj;
                        })
                        : [];
                    if (!flag) {
                        this.$set(this.deliverParam, 'locId', '')
                    }
                }
            },
            //获取所有运费模板
            async getTmsFrtOptions() {
                let resp = await LogisticsApi.getTmsFrtOptions({ suggest: '' });
                if (resp.succ == 1 && resp.result) {
                    this.tmsFrtOptions = resp.result.map(item => {
                        let obj = {};
                        obj.id = item.id;
                        obj.label = item.name;
                        return obj;
                    });
                }
            },

            //编辑卖家备注
            editBuyerRemark(tr) {
                this.sellerRemark = tr.sellerRemark;
                this.clickOrderNo = tr.orderNo;
                this.sellerRemarkPop = true;
            },
            //保存卖家备注
            async saveSellerRemark() {
                if (this.sellerRemark == '') {
                    this.$notifyError('请填写备注信息');
                } else if (this.clickOrderNo == '') {
                    this.$notifyError('订单编号获取失败');
                } else {
                    console.log(this.clickOrderNo);
                    let res = await OrderApi.updateOrderInfo({
                        orderNo: this.clickOrderNo,
                        sellerRemark: this.sellerRemark
                    });
                    this.sellerRemarkPop = false;
                    if (res.succ == 1) {
                        this.$notifySuccess('保存成功');
                        this.sellerRemark = '';
                        this.getOrderformList();
                    } else {
                        this.$notifyError(res.error);
                    }
                }
            },
            async download() {
                console.log(this.searchData,"查询条件")
                //组装下载参数
                let param = {
                    sourceChannelList: this.searchData.orderWay,
                    startTime: this.searchData.fromDate,
                    endTime: this.searchData.toDate,
                    orderStatusList: this.searchData.orderStatus,
                    orderNo: this.searchData.orderNo,
                    supplierType: this.searchData.supplierType,  //买家类型
                    dealerType: this.searchData.dealerType,  //买家类型
                    buyerType: this.searchData.buyerType, //左侧筛选条件：买家类型
                    buyer: this.searchData.buyer, //左侧筛选的买家
                    bodyId: this.searchData.bodyId, //主体名称
                    dealerTypeList: this.searchData.dealerTypeList
                };
                let url = '/data-dist/api/dist/ordering/export/order';
                let fileName = '订单列表导出.xlsx';
                // downloadExcel(url, param, fileName);
                const res = await OrderApi.orderdaofah(param)
            if(res.code=='0'){
                this.$notifySuccess(res.result)
            }else{
                this.$notifyError(res.error);
            }
            },
            //下载文件模板
            downloadTemplate() {
                downloadFileTemplate('/data-dist/api/dist/down/template/yooz_ordering', '订单导入模板.xlsx');
            },

            //拆单成功回调
            handleBreakUpOrderSuccess() {
                this.getOrderformList();
                this.$notifySuccess('拆单成功');
            },

            //合单成功回调
            //拆单成功回调
            handleCombineOrderSuccess() {
                this.getOrderformList();
                this.$notifySuccess('合并订单成功');
            }
        },
        watch: {
            // page: {
            //     handler() {
            //         this.getOrderformList();
            //     },
            //     deep: true
            // },
            sendData: {
                handler() {
                    this.validDeliver = this.sendData.every(item => item.frtId)
                    console.log('===this.validDeliver===', this.validDeliver);
                },
                deep: true
            }
        }

    };
</script>



<style lang="scss" scoped>
    @import '../orderoverseas/order.scss';
    @import '@/modules/commodity-sys/commodity.scss';

    /deep/.vs-con-dropdown {
        line-height: 11px;
    }

    .search-item-border {
        border-radius: 0 !important;
        padding-right: 15px;
        margin-right: 10px;
        border-right: 1px solid #000;
    }

    .search-item-right {
        padding-left: 10px;
        border-left: 1px solid #000;
        display: flex;
        position: absolute;
        right: 0;
    }

    .expectation {
        color: #ccc !important;
    }

    /deep/ .deliver-pop {
        position: relative;

        /deep/ .v-select {
            width: 350px;
        }

        button {
            width: 126px;
            height: 38px;
            font-size: 14px;
        }
    }

    /deep/ .vs-dialog .vs-table--content {
        height: 400px !important;
    }

    /deep/ .remark-text span {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .deliver-dialog {
        min-width: 800px;
    }

    .colTitle {
        line-height: 37px;
    }

    .deliver-btn {
        width: 100%;

        button {
            width: 126px;
            height: 38px;
            font-size: 14px;
        }
    }

    .edit-remark-textarea {
        width: 100%;
    }

    .follow-detail {
        .timeline-wrapper {
            width: 80%;
            margin: 0 auto;
            padding-top: 10px;
            max-height: 400px;
            overflow-y: auto;

            .addressee {
                display: flex;
                width: 80%;
                min-height: 50px;
                padding: 0 1.5rem 1rem 1.5rem;
                position: relative;
                left: 20%;

                .addressee-line {
                    position: absolute;
                    top: 5px;
                    left: 0;
                    width: 1px;
                    height: 100%;
                    background: #ebe9f1;
                }

                .addressee-item-point {
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    top: 0px;
                    z-index: 1;
                    left: -10px;
                    text-align: center;
                    border-radius: 50%;
                    background-color: rgb(64, 144, 255);

                    span {
                        text-align: center;
                        font-size: 12px;
                        line-height: 20px;
                        color: #fff;
                    }
                }

                .addressee-item-content {
                    font-size: 12px;
                }
            }
        }
    }

    .excrete-logo {
        display: inline-block;
        padding: 0;
        width: 20px;
        height: 20px;
        text-align: center;
        background: rgb(64, 144, 255);
        font-size: 13px;
        line-height: 20px;
        color: white;
        border-radius: 50%;
    }

    .el-table {
        border: none;

        /deep/ .el-table__row {
            .cell {
                white-space: pre-wrap;
            }
        }

        &::before {
            border: none;
            height: 0;
        }
    }

    .buyerName {
        color: #222;
    }

    .buyerType {
        font-size: 12px;
        color: #aaa;
    }

    .price-right {
        /deep/.vs-table-text {
            display: block;
            text-align: right;
        }
    }

    /deep/.vs-table--thead th {
        background: #fff;
    }

    .fixed-table-column {
        background: #fff !important;
    }

    .orderbox /deep/.vs-tabs--li {
        margin-right: 10px !important;
    }
</style>

<style lang="scss">
    .verify {
        .vs-dialog {
            height: 90vh;
            max-width: 1100px;

            .vs-dialog-text {
                // min-height: 500px;
            }

            .el-table__row {
                font-size: 12px;
            }

            .el-table td {
                padding: 2px 0 !important;
            }

            .el-table__body-wrapper {
                height: calc(100% - 50px);
                overflow-y: auto;
            }
        }
    }

    .el-select-dropdown {
        min-width: none !important;
        width: 200px !important;
    }
</style>
